import React from "react";

import visaIMG from "../../assets/images/cards/visa.svg";
import amexIMG from "../../assets/images/cards/amex.svg";
// import dinersIMG from "../../assets/images/cards/diners.svg";
import discoverIMG from "../../assets/images/cards/discover.svg";
// import jcbIMG from "../../assets/images/cards/jcb.svg";
import mastercardIMG from "../../assets/images/cards/mastercard.svg";

export default function LineCard({ cardInfo }) {
  function detectCreditCardBrand(string) {
    if (string) {
      const newString = string?.split("|");

      // Verifica o número do cartão de crédito com as expressões regulares
      if (newString[0].includes("VISA")) {
        return (
          <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
            <img style={{ width: 40 }} src={visaIMG} alt="visa" /> {newString[1]}
          </span>
        );
      } else if (newString[0].includes("MASTERCARD")) {
        return (
          <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
            <img style={{ width: 40 }} src={mastercardIMG} alt="visa" /> {newString[1]}
          </span>
        );
      } else if (newString[0].includes("AMERICAN")) {
        return (
          <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
            <img style={{ width: 40 }} src={amexIMG} alt="visa" /> {newString[1]}
          </span>
        );
      } else if (newString[0].includes("DISCOVER")) {
        return (
          <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}>
            <img style={{ width: 40 }} src={discoverIMG} alt="visa" /> {newString[1]}
          </span>
        );
        // } else if (regexDinersClub.test(cardNumber)) {
        //   return (
        //     <span>
        //       <img src={visaIMG} alt="visa" /> {newString[1]}
        //     </span>
        //   );
        // } else if (regexJCB.test(cardNumber)) {
        //   return (
        //     <span>
        //       <img src={visaIMG} alt="visa" /> {newString[1]}
        //     </span>
        //   );
      } else {
        return <span>{string}</span>;
      }
    } else {
      return <span>{string}</span>;
    }
  }

  return detectCreditCardBrand(cardInfo);
}
